import React, { useState, useEffect } from "react";
import { Surface } from "gl-react-dom";
import { Node } from "gl-react";
import { shaders } from "./lutShaders";

interface LutRendererProps {
  width: number;
  height: number;
  imageUrl: string;
  lutUrl: string | null;
  intensity: number;
}

export const LutRenderer: React.FC<LutRendererProps> = ({
  width,
  height,
  imageUrl,
  lutUrl,
  intensity,
}) => {
  const [imageDimensions, setImageDimensions] = useState({
    width: 1,
    height: 1,
  });
  const [imageLoaded, setImageLoaded] = useState(false);
  const [renderError, setRenderError] = useState<string | null>(null);

  const coverUv = {
    x: Math.max(1, width / imageDimensions.width),
    y: Math.max(1, height / imageDimensions.height),
  };

  useEffect(() => {
    if (imageUrl) {
      console.log("Loading image from URL:", imageUrl);
      try {
        const img = new window.Image();
        img.crossOrigin = "anonymous"; // Important for CORS issues

        img.onload = () => {
          console.log("Image loaded successfully:", img.width, "x", img.height);
          setImageDimensions({
            width: img.width,
            height: img.height,
          });
          setImageLoaded(true);
          setRenderError(null);
        };

        img.onerror = () => {
          console.error("Error loading image:");
          setImageLoaded(false);
          setRenderError("Erro ao carregar a imagem");
        };

        // Set the source after defining handlers
        img.src = imageUrl;
        if (img.complete) {
          setImageDimensions({ width: img.width, height: img.height });
          setImageLoaded(true);
          setRenderError(null);
        }
      } catch (error) {
        console.error("Exception loading image:", error);
        setRenderError("Erro ao processar a imagem");
      }
    } else {
      console.log("No image URL provided");
      setImageLoaded(false);
    }
  }, [imageUrl]);

  if (renderError) {
    return (
      <div
        style={{
          width,
          height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#000",
          color: "white",
        }}
      >
        <p>{renderError}</p>
      </div>
    );
  }

  if (!imageUrl || !imageLoaded) {
    console.log("No image URL provided to LutRenderer");
    return null;
  }

  return (
    <Surface width={width} height={height} style={{ width, height }}>
      <Node
        shader={shaders.lutApplier}
        uniforms={{
          image: imageUrl,
          lut: lutUrl,
          coverUv: [coverUv.x, coverUv.y],
          percentage: intensity,
        }}
      />
    </Surface>
  );
};
